import { useAuthStore } from '../../store/useAuthStore';
import { LogoMark } from '../common/Logo';

export default function LoginPage() {
  const { login, error } = useAuthStore();

  const handleLogin = async () => {
    try {
      await login();
    } catch (err: any) {
      console.error('Login redirect failed:', err);
      useAuthStore.setState({ error: err.message || 'Failed to start login flow' });
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="w-full max-w-md">
        {/* Logo / Brand */}
        <div className="text-center mb-8">
          {/* Clear space of at least the mark's height on all sides, which
              this screen has room for and the rail does not. */}
          <div className="inline-flex items-center justify-center w-24 h-24 mb-2 text-white">
            <LogoMark className="h-12 w-12" />
          </div>
          <h1 className="text-3xl font-bold text-white">Heuristic Systems</h1>
          <p className="text-slate-400 mt-2">Project Management Office</p>
        </div>

        {/* Login Card */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 text-center mb-2">
            Welcome back
          </h2>
          <p className="text-sm text-gray-500 dark:text-gray-400 text-center mb-8">
            Sign in with your Google account to continue
          </p>

          {error && (
            <div className="mb-6 p-3 rounded-lg bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800">
              <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
            </div>
          )}

          <button
            onClick={handleLogin}
            className="w-full flex items-center justify-center gap-3 px-4 py-3 rounded-xl bg-white dark:bg-gray-700 border-2 border-gray-200 dark:border-gray-600 hover:border-accent hover:bg-gray-50 dark:hover:bg-gray-600 transition-all duration-200 group"
          >
            {/* Google icon */}
            <svg width="20" height="20" viewBox="0 0 24 24" className="shrink-0">
              <path
                fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
              />
              <path
                fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            <span className="text-sm font-medium text-gray-700 dark:text-gray-200 group-hover:text-accent">
              Sign in with Google
            </span>
          </button>

          <div className="mt-6 pt-6 border-t border-gray-100 dark:border-gray-700">
            <p className="text-xs text-gray-400 dark:text-gray-500 text-center">
              Access is restricted to authorized HSINC team members.
              <br />
              Contact your administrator if you need access.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
